import {Controller} from "@hotwired/stimulus";
import {Sortable} from "@shopify/draggable";

export default class extends Controller {
    static targets = ["list", "input"]

    connect() {
        this.sortable = new Sortable(this.listTarget, {
            draggable: ".sortable-position",
        })

        this.sortable.on("sortable:stop", () => {
            // add delay to give sortable time to delete the mirrored element; else it would fuck up the index
            setTimeout(() => {
                this.updatePositions();
            }, 5)
        })
    }

    updatePositions() {
        let items = [...this.listTarget.querySelectorAll(".sortable-position")]

        items.forEach((item, index) => {
            item.querySelector(".sortable-position-index").textContent = index + 1
        })

        let ids = items.map(item => item.dataset.id)
        this.inputTarget.value = ids.join(",")
    }
}
